import { Controller } from "@hotwired/stimulus"

// Linha de contato do local da remoção: quem recebe o motorista precisa estar
// identificado por completo (nome, telefone e CPF). Mas exigir tudo de uma
// linha em branco travaria o formulário — então a obrigatoriedade acompanha o
// preenchimento: começou a linha, exige os três; linha vazia é ignorada.
// A primeira linha é sempre obrigatória (sempre há alguém recebendo).
export default class extends Controller {
  static targets = ["field"]
  static values = { always: Boolean }

  connect() {
    this.sync()
  }

  sync() {
    const started = this.fieldTargets.some((field) => field.value.trim() !== "")
    const required = this.alwaysValue || started

    this.fieldTargets.forEach((field) => {
      field.required = required
      field.setAttribute("aria-required", required ? "true" : "false")
    })
  }
}
